import { BG_VIDEO } from "@/constants/video";
import clsx from "clsx";

interface IBackgroundProps
  extends Pick<React.HTMLAttributes<HTMLDivElement>, "className"> {
  src?: string;
}

const BackgroundVideo = (props: IBackgroundProps) => {
  return (
    <div
      className={clsx(
        "fixed top-0 left-0 w-full h-full z-[-1] overflow-hidden rounded-2xl",
        props.className,
      )}
    >
      <video
        className="object-cover w-full h-full z-[-1]"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="/images/preview_video.webp"
      >
        <source src={props.src || BG_VIDEO} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default BackgroundVideo;
